import React, { memo } from 'react'
import s from '../../css/changes/changesItem.module.css'

const ChangesItem = memo(({ id, title, description, date, isNew }) => {
	return (
		<li className={s.tag}>
			<div className={s.rail} aria-hidden='true'>
				<span className={`${s.dot} ${isNew ? s.dotNew : ''}`} />
				<span className={s.line} />
			</div>
			<article
				className={`common__body ${s.card} ${isNew ? s.cardNew : ''}`}
				id={id}
			>
				<div className={s.meta}>
					<time className={s.date}>{date}</time>
					{isNew && <span className={s.badge}>Новое</span>}
				</div>
				<h3>{title}</h3>
				<p className='common__text'>{description}</p>
			</article>
		</li>
	)
})

export default ChangesItem
